<template>
  <div class="attachments-wrapper text-center">
    <swiper :slidesPerView="3" :spaceBetween="30" :breakpoints="{
      320: {
        slidesPerView: 1,
        spaceBetween: 12,
      },
      768: {
        slidesPerView: 1,
        spaceBetween: 12,
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 12,
      },
      1700: {
        slidesPerView: 4,
        spaceBetween: 12,
      },
    }" :navigation="true" :modules="modulesmodal" class="mySwiper">
      <swiper-slide v-for="(attachment, index) in attachments" :key="index" @click="openmodal(index)"
        class="bg-light card p-1" style="height: 290px">
        <a v-if="attachment.type_file !== 'dcm'" :href="attachment.path" target="_blank" rel="noopener noreferrer"
          class="attachment-link" @click.stop title="Apri in una nuova scheda">
          <i class="las la-external-link-alt"></i>
        </a>
        <figure class="product-main-image card-body">
          <div style="height: 210px!important;max-width: 270px !important">
            <div v-if="
              attachment.type_file == 'mp4' || attachment.type_file == 'mv4'
            ">
              <video-component :options="getOptons(attachment.path)"
                :preload="'video-js vjs-layout-tiny'"></video-component>
            </div>
            <div v-else-if="
              attachment.type_file == 'jpg' ||
              attachment.type_file == 'jpeg' ||
              attachment.type_file == 'png'
            " class="d-flex justify-content-center">
              <img :src="attachment.path" class="card-img-top" style="max-width: 240px; max-height: 160px" />
            </div>
            <div v-else-if="attachment.type_file == 'dcm'">
              <iframe :src="url +
                '?domain=' +
                this.domain +
                '&id=' +
                attachment.id +
                '&token=' +
                token +
                '&width=100' +
                '&height=100' +
                '&margin=nomargin'
                " width="250" height="200"></iframe>
            </div>
            <div v-if="attachment.type_file == 'pdf'" class="d-flex justify-content-center align-items-center w-100">
              <iframe class="pdf-frame" :src="attachment.path" frameborder="0" allowfullscreen></iframe>
            </div>
            <div v-else-if="
              attachment.type_file != 'pdf' &&
              attachment.type_file != 'dcm' &&
              attachment.type_file != 'jpg' &&
              attachment.type_file != 'jpeg' &&
              attachment.type_file != 'png' &&
              attachment.type_file != 'mp4' &&
              attachment.type_file != 'm4v'
            ">
              <iframe class="embed-responsive-item" :src="attachment.path" allowfullscreen>Contenuto
              </iframe>
            </div>
          </div>
          <div class="pl-4 pr-4">
            <div class="col-12 text-truncate" style="font-size: 15px; max-width: 250px">
              {{ attachment.name }}
            </div>
          </div>
        </figure>

        <div class="d-flex align-items-center text-center">
          <button type="button" class="btn-xs btn" style="text-transform: capitalize !important"
            @click="openmodalButton(index)">
            <span class="small badge rounded-pill badge-primary border" style="font-size: 17px"><i
                class="las la-search"></i></span>
          </button>
        </div>
      </swiper-slide>
    </swiper>
    <div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true"
      id="modal-attachments">
      <div class="modal-dialog modal-dialog-centered modal-xl" style="max-width: 90%">
        <div class="modal-content p-4">
          <div class="row p-1">
            <div class="w-100 p-2 float-right">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                style="background-color: transparent; border: 0">
                <span aria-hidden="true" style="font-size: 25px">×</span>
              </button>
            </div>
            <!--:ref="mySwiper"-->
            <swiper :navigation="true" :modules="modulesmodal" @swiper="onSwiper" class="mySwiper">
              <swiper-slide v-for="(attachment, index) in attachments" :key="index">


                <figure class="product-main-image" style="height: 720px;">
                  <a v-if="attachment.type_file !== 'dcm'" :href="attachment.path" target="_blank"
                    rel="noopener noreferrer" @click.stop title="Apri in una nuova scheda">
                    <i class="las la-external-link-alt"></i>
                  </a>
                  <div v-if="
                    attachment.type_file == 'mp4' ||
                    attachment.type_file == 'mv4'
                  " style="height: 700px;width: 600px;">
                    <div class="embed-responsive embed-responsive-16by9">
                      <iframe class="embed-responsive-item" :src="attachment.path" allowfullscreen></iframe>
                    </div>

                  </div>
                  <div v-else-if="
                    attachment.type_file == 'jpg' ||
                    attachment.type_file == 'jpeg' ||
                    attachment.type_file == 'png'
                  ">
                    <img :src="attachment.path" class="custom-zoom" />
                  </div>
                  <div v-else-if="attachment.type_file == 'pdf'">
                    <div class="pdf-container-modal">
                      <iframe class="pdf-frame-modal" :src="attachment.path" frameborder="0"></iframe>
                    </div>

                  </div>
                  <div v-else-if="attachment.type_file == 'dcm'">
                    <a class="btn btn-primary" :href="'/casi-clinici/visualizzatore-dicom/' + attachment.id
                      ">Clicca qui per analizzare i dicom</a>
                  </div>
                </figure>
              </swiper-slide>
            </swiper>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import VideoComponent from "@/components/VideoComponent.vue";

// Import Swiper styles
import "swiper/css";

import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/free-mode";

// import required modules
import { Pagination, Mousewheel, Keyboard, Navigation } from "swiper";
import $ from "jquery";
window.jQuery = $;
window.$ = $;

export default {
  name: "SwiperComponents",
  props: ["attachments", "showname"],
  components: {
    Swiper,
    SwiperSlide,
    VideoComponent,
  },
  setup() {
    return {
      modulesmodal: [Navigation, Pagination, Mousewheel, Keyboard],
    };
  },
  data() {
    return {
      loaded: false,
      initialSlideModal: 0,
      domain: "",
      token: "",
      url: "",
    };
  },
  mounted() {
    this.token = localStorage.getItem("token");
    switch (window.location.hostname)
    {
      case "localhost":
        this.domain = "https://gestione.vascularclass.it";
        this.url = "http://localhost:8080";
        break;
      case "demo.vascularclass.it":
        this.domain = "https://test.gestione.vascularclass.it";
        this.url = "https://demo-dicom-viewer-du674cefya-oc.a.run.app";
        break;
      case "www.vascularclass.it":
      case "vascularclass.it":
        this.domain =
          "https://gestione.vascularclass.it";
        this.url = "https://dicom-viewer-du674cefya-oc.a.run.app";
        break;
    }
    $(document).on("show.bs.modal", ".modal", function () {
      $(this).appendTo("body");
    });
  },
  created() { },
  methods: {
    onSwiper(swiper) {
      this.swiper = swiper;
    },

    getOptons(path) {
      return {
        controls: true,
        autoplay: false,
        fluid: true,
        responsive: true,

        aspectRatio: '16:9',
        // Puoi aggiungere ulteriori opzioni personalizzate qui

        // Esempio di configurazione del sorgente del video
        sources: [
          {
            src: path,
            type: "video/mp4",
          },
        ],
      };
    },
    changeSlide(index) {
      this.swiper.slideTo(index);
    },
    openmodalButton(index) {
      this.changeSlide(index);
      $("#modal-attachments").modal("show");
    },
    openmodal(index) {
      if (this.attachments[index].type_file != 'mp4' && this.attachments[index].type_file != 'dcm')
      {
        console.log(index);

        this.changeSlide(index);
        $("#modal-attachments").modal("show");
      } else if (this.attachments[index].type_file == 'dcm')
      {
        window.location.href = '/casi-clinici/visualizzatore-dicom/' + this.attachments[index].id;
      }

    },
  },
};
</script>

<style>
.swiper {
  width: 100%;
  height: 100%;
  max-height: 500px;
}

.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;

  /* Center slide text vertically */
  display: flex;
  justify-content: center;
  align-items: center;
}

.swiper-slide img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.vjs-layout-tiny {
  height: 180px !important;
  max-height: 180px !important;
  display: contents !important;
}



.attachment-link {
  position: absolute;
  top: 8px;
  right: 10px;
  font-size: 16px;
  color: #007bff;
  opacity: 0.7;
  transition: opacity 0.2s, transform 0.2s;
  z-index: 10;
}

.attachment-link:hover {
  opacity: 1;
  transform: scale(1.1);
  color: #0056b3;
}




.pdf-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 210px;
  max-width: 100%;
  overflow: hidden;
}

.pdf-frame {
  width: 90%;
  height: 100%;
  border-radius: 6px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.15);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.pdf-frame:hover {
  transform: scale(1.02);
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.25);
}

/* PDF container nel modal (grande e centrato) */
.pdf-container-modal {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 70vh;
}

.pdf-frame-modal {
  width: 80%;
  height: 70vh;
  max-width: 1000px;
  border-radius: 10px;
  border: none;
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.2);
}
</style>